import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import ChargingTransactionTable from "../../components/charging/ChargingTransactionComponent/ChargingTransactionTable";
import { Box, Tab, Tabs, CircularProgress } from '@mui/material';
import { checking_null_undefined } from "utils";
import { useApiService } from "../../services/ApiService/ApiService";

function ChargingTransactionListPage(props: any) {
    const { userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [providerTransactions, setProviderTransactions] = useState([]) as any;
    const [consumerTransactions, setConsumerTransactions] = useState([]) as any;
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);

    const fetchTransactions = async () => {
        let bodyData: { [name: string]: string } = {};
        bodyData["uuid"] = userInfo.uuid;
        bodyData["businessUuid"] = userInfo.businessUuid;
        bodyData["fleetUuid"] = userInfo.fleetUuid;

        try {
            const response = await fetchWithAuth('/charging-transaction/list', {
                method: 'POST',
                body: JSON.stringify(bodyData),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch transactions');
            }

            const res_json = await response.json();
            console.log(JSON.stringify(res_json));

            setProviderTransactions(checking_null_undefined(res_json.chargingTransactionsInbound).map((e: any) => ({ ...e, id: e.uuid, partnerName: e.partnerName, partnerUuid: e.partnerUuid, transactionDate: new Date(Date.parse(e.transactionDate)).toLocaleDateString(), partnerCost: "£" + e.partnerCost.toFixed(2), income: "£" + e.income.toFixed(2), chargeAmountKWh: e.chargeAmountKWh.toFixed(2), chargeTimeInMins: e.chargeTimeInMins, addressLine: e.addressLine, registrationNumber: e.registrationNumber })));
            setConsumerTransactions(checking_null_undefined(res_json.chargingTransactionsOutbound).map((e: any) => ({ ...e, id: e.uuid, partnerName: e.partnerName, partnerUuid: e.partnerUuid, transactionDate: new Date(Date.parse(e.transactionDate)).toLocaleDateString(), partnerCost: "£" + e.partnerCost.toFixed(2), income: "£" + e.income.toFixed(2), chargeAmountKWh: e.chargeAmountKWh.toFixed(2), chargeTimeInMins: e.chargeTimeInMins, addressLine: e.addressLine, registrationNumber: e.registrationNumber })));

            console.log(res_json.chargingTransactionsHome);
            console.log(res_json.chargingTransactionsAway);
        } catch (error) {
            console.error('Error fetching transactions:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTransactions();
    }, []);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    if (loading) {
        return (
            <Box 
                component="section" 
                sx={{ p: 3 }}
            >
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </Box>
            </Box>
        );
    }

    return (
        <Box 
            component="section"
            sx={{ p: 3 }}
        >
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs 
                        value={activeTab} 
                        onChange={handleTabChange}
                        aria-label="charging transaction tabs"
                    >
                        <Tab label="As Charge Provider" />
                        <Tab label="As Charge Consumer" />
                    </Tabs>
                </Box>

                <Box>
                    {activeTab === 0 && (
                        <ChargingTransactionTable 
                            chargingTransactions={providerTransactions} 
                            transactionDirection="INBOUND"
                        />
                    )}
                    {activeTab === 1 && (
                        <ChargingTransactionTable 
                            chargingTransactions={consumerTransactions} 
                            transactionDirection="OUTBOUND"
                        />
                    )}
                </Box>
            </Box>
        </Box>
    );
}

export default ChargingTransactionListPage;
